"use client";

import { useHyperliquidConnection } from "@/hooks/trade/hyperliquid/useHyperliquidConnection";

export function useAirdropHyperliquidConnection(options?: { agentName?: string }) {
  return useHyperliquidConnection({ ...options, mode: "airdrop" });
}
